(() => {
  const config = window.dgOcuCartTranslations;
  if (!config || !Array.isArray(config.exact)) return;

  const translationRootSelector = '.ocu-cart-drawer, .ocu-popup.ocu-pre';
  const exact = new Map(config.exact);
  const rootObservers = new WeakMap();

  const translateValue = (value) => {
    if (typeof value !== 'string') return value;

    const leading = value.match(/^\s*/)?.[0] || '';
    const trailing = value.match(/\s*$/)?.[0] || '';
    const core = value.trim();
    if (!core) return value;

    if (exact.has(core)) return `${leading}${exact.get(core)}${trailing}`;

    if (/^Offre spéciale rien que pour toi\s*🎁$/i.test(core) && config.specialOffer) {
      return `${leading}${config.specialOffer}${trailing}`;
    }

    if (/^L['’]offre expire dans\s*:$/i.test(core) && config.offerExpiresIn) {
      return `${leading}${config.offerExpiresIn}${trailing}`;
    }

    const extraDiscount = core.match(/^(?:(.+?)\s+)?de (?:rabais|remise) supplémentaire$/i);
    if (extraDiscount && config.extraDiscount) {
      const amount = extraDiscount[1] ? `${extraDiscount[1]} ` : '';
      return `${leading}${amount}${config.extraDiscount}${trailing}`;
    }

    if (/^redirection en cours\s*(?:\.{3}|…)?$/i.test(core) && config.redirecting) {
      return `${leading}${config.redirecting}${trailing}`;
    }

    if (/^Bravo\s*🎉\s*Livraison offerte débloquée\s*!$/i.test(core) && config.rewardUnlocked) {
      return `${leading}${config.rewardUnlocked}${trailing}`;
    }

    if (/^Prix garantis jusqu['’]à$/i.test(core) && config.priceGuaranteedUntil) {
      return `${leading}${config.priceGuaranteedUntil}${trailing}`;
    }

    if (/^d['’]économie$/i.test(core) && config.savingsSuffix) {
      return `${leading}${config.savingsSuffix}${trailing}`;
    }

    const freeShippingTier = core.match(
      /^(?:Expédition gratuite|Livraison (?:gratuite|offerte))\s*\(\s*dès\s+(.+?)\s+d['’]achat\s*\)$/i
    );
    if (freeShippingTier && config.freeShippingFrom) {
      return `${leading}${config.freeShippingFrom.replace('__AMOUNT__', freeShippingTier[1])}${trailing}`;
    }

    const freeItemTier = core.match(/^Article gratuit dès\s+(.+?)\s+d['’]achat$/i);
    if (freeItemTier && config.freeItemFrom) {
      return `${leading}${config.freeItemFrom.replace('__AMOUNT__', freeItemTier[1])}${trailing}`;
    }

    const freeDelivery = core.match(/^(?:Plus que|Encore)\s+(.+?)\s+pour (?:profiter|bénéficier) de la livraison gratuite\s*!?$/i);
    if (freeDelivery && config.spendMore) {
      return `${leading}${config.spendMore.replace('__AMOUNT__', freeDelivery[1])}${trailing}`;
    }

    const saving = core.match(/^(?:Tu économises|Vous économisez)\s*:?\s*(.+)$/i);
    if (saving && config.saveAmount) {
      return `${leading}${config.saveAmount.replace('__AMOUNT__', saving[1])}${trailing}`;
    }

    return value;
  };

  const translateTextNode = (textNode) => {
    if (textNode.parentElement?.closest('script, style, template')) return;

    const translated = translateValue(textNode.nodeValue);
    if (translated !== textNode.nodeValue) textNode.nodeValue = translated;
  };

  const translateAttribute = (element, attribute) => {
    if (!(element instanceof Element) || !element.hasAttribute(attribute)) return;

    const current = element.getAttribute(attribute);
    const translated = translateValue(current);
    if (translated !== current) element.setAttribute(attribute, translated);
  };

  const translateRoot = (root) => {
    if (!(root instanceof Element)) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let textNode;
    while ((textNode = walker.nextNode())) {
      translateTextNode(textNode);
    }

    const translatableAttributes = ['placeholder', 'aria-label', 'title'];
    translatableAttributes.forEach((attribute) => translateAttribute(root, attribute));
    root.querySelectorAll('[placeholder], [aria-label], [title]').forEach((element) => {
      translatableAttributes.forEach((attribute) => translateAttribute(element, attribute));
    });
  };

  const translateAddedNode = (node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      translateTextNode(node);
    } else if (node instanceof Element) {
      translateRoot(node);
    }
  };

  const observeRoot = (root) => {
    if (!(root instanceof Element) || rootObservers.has(root)) return false;
    if (root.parentElement?.closest(translationRootSelector)) return false;

    translateRoot(root);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') {
          translateTextNode(mutation.target);
        } else if (mutation.type === 'attributes') {
          translateAttribute(mutation.target, mutation.attributeName);
        } else {
          mutation.addedNodes.forEach(translateAddedNode);
        }
      });
    });

    observer.observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['placeholder', 'aria-label', 'title']
    });

    rootObservers.set(root, observer);
    return true;
  };

  const registerRoots = (scope) => {
    if (!scope) return false;

    let registered = false;
    const register = (root) => {
      if (observeRoot(root)) registered = true;
    };

    if (scope instanceof Element && scope.matches(translationRootSelector)) register(scope);
    scope.querySelectorAll?.(translationRootSelector).forEach(register);
    return registered;
  };

  const initialise = () => {
    registerRoots(document);
    document.addEventListener('dg:ocu-root-ready', (event) => observeRoot(event.detail));
    window.dgRequestOcuDiscovery?.();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();
